import React, { useState } from 'react'
import { getPlacedObjectSizeInches } from './layoutSerializer'
import ArtworkSizeControls from './ArtworkSizeControls'

export default function ArtworkCopyList({ image, objects, selectedObject, sheetNumber, sheetSize, disabled, onSelect, onChange, onAdd, onRemove }) {
  const [expanded, setExpanded] = useState(false)
  const selected = objects.find(object => object.objectId === selectedObject?.objectId)
  const size = getPlacedObjectSizeInches(selected)
  return (
    <>
      {selected && size && (
        <section className="artwork-copy-inspector" aria-label={`Selected copy of ${image.originalFilename}`}
          data-testid={`artwork-card-controls-${selected.objectId}`}>
          <strong>Selected copy size · Sheet {sheetNumber}</strong>
          <p className="graphics-panel__helper">Size changes here affect only this copy.</p>
          <ArtworkSizeControls key={selected.objectId} id={selected.objectId} image={image}
            width={size.widthIn} height={size.heightIn}
            sheetSize={sheetSize} disabled={disabled}
            onChange={dimensions => onChange?.(selected.objectId, dimensions)} />
          <div className="artwork-card__actions">
            <button type="button" disabled={disabled} data-testid={`artwork-card-add-copy-${selected.objectId}`} onClick={() => onAdd?.(selected.objectId)}>Add copy</button>
            <button type="button" disabled={disabled} data-testid={`artwork-card-remove-copy-${selected.objectId}`} onClick={() => onRemove?.(selected.objectId)}>Remove this copy</button>
          </div>
          <p className="graphics-panel__helper">Add copy duplicates this size and selects the new copy. Click empty canvas space to finish editing this copy.</p>
        </section>
      )}
      {objects.length > 0 && (
        <div className="artwork-copy-list">
          <button type="button" className="artwork-card__edit-cue" aria-expanded={expanded}
            onClick={() => setExpanded(value => !value)}>
            {expanded ? 'Hide' : 'Show'} copies on Sheet {sheetNumber} ({objects.length})
          </button>
          {expanded && (
            <ul aria-label={`Copies of ${image.originalFilename} on Sheet ${sheetNumber}`}>
              {objects.map((object, index) => {
                const dimensions = getPlacedObjectSizeInches(object)
                return (
                  <li key={object.objectId}>
                    <button type="button" disabled={disabled || object.selectable === false || object.evented === false}
                      aria-pressed={object.objectId === selected?.objectId}
                      onClick={() => onSelect(object.objectId)}>
                      Copy {index + 1}
                      {dimensions && <span>{Number(dimensions.widthIn.toFixed(2))}&quot; × {Number(dimensions.heightIn.toFixed(2))}&quot;</span>}
                    </button>
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      )}
    </>
  )
}
